module.exports = __webpack_public_path__ + "static/media/lenox-park-bylaws.72993448.pdf";